var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3848 7.61519C39.474 2.7044 32.9448 0 26 0C19.0552 0 12.526 2.7044 7.61519 7.61519C2.7044 12.526 0 19.0552 0 26C0 32.9448 2.7044 39.474 7.61519 44.3848C12.526 49.2956 19.0551 52 26 52C32.9449 52 39.474 49.2956 44.3848 44.3848C49.2956 39.474 52 32.9449 52 26C52 19.0551 49.2956 12.526 44.3848 7.61519ZM37.4911 23.6571C37.232 24.2826 36.6218 24.6904 35.9448 24.6904H31.6517V38.9284C31.6517 39.8527 30.9023 40.6022 29.9779 40.6022H22.0221C21.0977 40.6022 20.3483 39.8527 20.3483 38.9284V24.6904H16.0551C15.3781 24.6904 14.7679 24.2827 14.5088 23.6571C14.2498 23.0317 14.3929 22.3117 14.8716 21.833L24.8164 11.8882C25.1303 11.5743 25.556 11.3978 25.9999 11.3978C26.4438 11.3978 26.8696 11.5742 27.1834 11.8882L37.1281 21.833C37.607 22.3117 37.7502 23.0316 37.4911 23.6571Z",
    fill: "#0E4542"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d5bc8050.svg";
export { ForwardRef as ReactComponent };